export const configLfmUpperDh = {
  "Controller": {
    "Name": "EXPO_NumericalDBExt",
    "data": "JMA_SRF_LFM_UPPER",    
    "tile_size": 256
  },
  "Source": {
    "basetime": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/basetimes?use=map",
      "validtimes": 1,
      "time_to_target_for_comparison": 24,
      "retain": true,
      "cache_busting": "YYYYMMDDhhmm",
    },
    "validtime": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/valid_times?basetime=%basetime%&use=map",
      "retain": true,
      "cache": false,
      "cache_busting": true,
    },
    "region": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/area_info?use=map",
      "retain": true,
      "cache": true
    },
    "level": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/levels?use=map",
      "retain": true,
      "cache": true
    },
    "element": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/detailed_elements?use=map",
      "retain": true,
      "cache": true
    },
      "data": {
      "Type": "Binary",
      "url": "%numerical_db_gpv_url%/%data%/stride",
      "post_data": "{\"basetime\":\"%basetime%\",\"valid_time\":[\"%validtime%\"],\"elements\":[\"%element%\"],\"levels\" :[\"%level%\"],\"start_IGRID\" :%sx%,\"start_JGRID\":%sy%,\"end_IGRID\":%ex%,\"end_JGRID\":%ey%,\"stride_IGRID\":%dx%,\"stride_JGRID\":%dy%}",
      "alias": {
        "element": {
          "TMP": "AIRTMP",
          "RH": "RHUM"
        },
        "level": {
          "000": "0"
        }
      },
      "cache": true
    },
    "timelist": {
      "Type": "Derived",
      "retain": true,
      "cache": false,
      "cache_busting": true,
      "update_interval": 60,
    },
    "updatetime": {
      "Type": "JSON",
      "url": "%numerical_db_gpv_url%/%data%/update_time",
      "post_data": "{\"basetime\":\"%basetime%\",\"valid_time\":%validtime%,\"elements\":%element%,\"level\":%level%}"
    }
  }
}

export const configLfmUpperSpeedDirectionController = {
  "Controller": {
    "Name": "SpeedDirectionConverter",
    "UElement": "UWIND",
    "VElement": "VWIND"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "reference": configLfmUpperDh,
      "retain": true
    },
    "data": {
      "Type": "Derived",
      "reference": configLfmUpperDh
    }
  }
};

export const configLfmUpperUpConversionController = {
  "Controller": {
    "Name": "UpConversionFilter",
    "peak_filtering": true,
    "MaxScale": 4
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "reference": configLfmUpperDh,
      "retain": true
    },
    "data": {
      "Type": "Derived",
      "reference": configLfmUpperDh
    }
  }
}

export const configLfmUpperIcingProbController = {
  "Controller": {
    "Name": "IcingProbability",
    "TMPElement": "TMP",
    "RHElement": "RH"
  },
  "Source": {
    "timelist": {
      "Type": "JSON",
      "reference": configLfmUpperDh,
      "retain": true
    },
    "data": {
      "Type": "Derived",
      "reference": configLfmUpperDh,
    }}
}

// 風 矢羽
export const configLfmUpperLayerWindArrow = {
  "Name": "GPVWindArrow",
  "Renderer": "WindArrow",
  "Attributes": {
    "style": {
      "default": {
        "min_blocksize": 40,
        "overlap_range": 80,
        "color": "rgb(156,97,44)"
      }
    }
  }
};

// 風 流線
export const configLfmUpperLayerStreamLine = {
  "Name" : "StreamLine",
  "Renderer" : "StreamLine",
  "Attributes" : {
    "data_scale" : 1.94384,
    // "min" : "1.0,     流線の生成を行う最低速度（デフォルト1.0）",
    // "scale" : "0.01,  UV値から緯度経度距離に変換する調整係数。大きくすると流線の点間隔が荒くなる。（デフォルト0.01）",
    // "times" : "80,     一本の流線を生成するシミュレーション回数＝流線が何本の折れ線で構成されるか（デフォルト80）",
    // "lines" : "10000,  生成する流線の数（デフォルト10000）",
    // "duration" : "10,  一本の流線のアニメーション時間（秒：デフォルト10）",
    // "separation" : "1, 一本の流線をいくつの部分に分割して表示するか（デフォルト1）（整数）",
    // "display" : "0.5,  一本の流線全体の中で、表示されている部分の比率（デフォルト0.5）",
    "min" : 1.0,
    "scale" : 0.01,
    "times" : 40,
    "lines" : 5000,
    "duration" : 3,
    "separation" : 1,
    "display" : 0.3,
    "style" : {
      "default" : {
        "palette_gradient": true,
        "palette_step": 0.1,
        "palette" : [
          {
            "value" : 0.1,
            "color" : "rgba(200,0,255,0.0)"
          },
          {
            "value" : 2.0,
            "color" : "rgba(0,0,255,0.7)"
          },
          {
            "value" : 10.0,
            "color" : "rgba(32,200,255,1.0)"
          },
          {
            "value" : 20.0,
            "color" : "rgba(48,255,255,1.0)"
          },
          {
            "value" : 40.0,
            "color" : "rgba(255,255,48,1.0)"
          },
          {
            "value" : 60.0,
            "color" : "rgba(255,0,0,1.0)"
          }
        ]
      }
    }
  }
}

// 風 等風速線 Contour
export const configLfmUpperLayerIsotach = {
  "Name" : "IsotachContour",
  "Renderer" : "Contour",
  "Attributes" : {
    "data_scale": 1.94384449,
    "data_offset": 0,
    "style" : {
      "default": {
        "contour": [
          {
            "base":20,
            "interval":20,
            "num": 4,
            "lineWidth": 1,
            "strokeStyle": "rgba(30, 144, 255, 0.7)",
            "textColor": "rgba(30, 144, 255, 1)",
            "fontSize": 14
          },
          {
            "base":100,
            "interval":20,
            "num": 3,
            "label_interval": 250,
            "lineWidth": 1,
            "strokeStyle": "rgba(78, 190, 78, 0.7)",
            "textColor": "rgba(78, 190, 78, 1)",
            "fontSize": 14
          },
          {
            "base":160,
            "interval":20,
            "num": 2,
            "label_interval": 125,
            "lineWidth": 1,
            "strokeStyle": "rgba(247, 200, 127, 0.7)",
            "textColor": "rgba(247, 200, 127, 1)",
            "fontSize": 14,
          }
        ]
      }
    }
  }
};

// 風 等風速線 Mesh
export const configLfmUpperLayerIsotachMesh = {
  "Name" : "IsotachFill",
  "Renderer" : "Mesh",
  "Attributes" : {
    "data_scale": 1.94384449,
    "data_offset": 0,
    "style" : {
      "default": {
        "fill_type" : "flat",
        "palette_gradient": false,
        "palette_step": 1,
        "palette" : [
          {
            "value" : 100.0,
            "color" : "rgba(144, 238, 144, 0.5)"
          },
          {
            "value" : 160.0,
            "color" : "rgba(250, 250, 210, 0.5)"
          },
          {
            "value" : 300.0,
            "color" : "rgba(250, 250, 210, 0.5)"
          }
        ]
      }
    }
  }
}

// 風 等風速線 Mesh Gradation
export const configLfmUpperLayerIsotachGradation = {
  "Name" : "IsotachFillGradation",
  "Renderer" : "Mesh",
  "Attributes" : {
    "style" : {
      "default": {
        "fill_type": "gradation",
        "palette_gradient": true,
        "palette_step": 1,
        "palette": [
          {
            "value": 0,
            "color": "rgba(98,113,183,0.5)"
          },
          {
            "value": 1,
            "color": "rgba(57,97,159,0.5)"
          },
          {
            "value": 3,
            "color": "rgba(74,148,169,0.5)"
          },
          {
            "value": 5,
            "color": "rgba(77,141,123,0.5)"
          },
          {
            "value": 7,
            "color": "rgba(83,165,83,0.5)"
          },
          {
            "value": 9,
            "color": "rgba(53,159,53,0.5)"
          },
          {
            "value": 11,
            "color": "rgba(167,157,81,0.5)"
          },
          {
            "value": 13,
            "color": "rgba(159,127,58,0.5)"
          },
          {
            "value": 15,
            "color": "rgba(161,108,92,0.5)"
          },
          {
            "value": 17,
            "color": "rgba(129,58,78,0.5)"
          },
          {
            "value": 19,
            "color": "rgba(175,80,136,0.5)"
          },
          {
            "value": 21,
            "color": "rgba(117,74,147,0.5)"
          },
          {
            "value": 24,
            "color": "rgba(109,97,163,0.5)"
          },
          {
            "value": 27,
            "color": "rgba(68,105,141,0.5)"
          },
          {
            "value": 29,
            "color": "rgba(92,144,152,0.5)"
          },
          {
            "value": 36,
            "color": "rgba(125,68,165,0.5)"
          },
          {
            "value": 46,
            "color": "rgba(231,215,215,0.5)"
          },
          {
            "value": 51,
            "color": "rgba(219,212,135,0.5)"
          },
          {
            "value": 77,
            "color": "rgba(205,202,112,0.5)"
          },
          {
            "value": 104,
            "color": "rgba(128,128,128,0.5)"
          }
        ]
      }
    }
  }
}

// 気温 等値線
export const configLfmUpperLayerIsotherm = {
  "Name": "GPVTempContour",
  "Renderer": "Contour",
  "Attributes": {
    "data_offset": -273.15,
    "style_selector": {
      "key": "level",
      "styles": [
        {
          "values": [
            "1000",
            "975",
            "950",
            "925",
            "900",
            "850"
          ],
          "style": "low"
        },
        {
          "values": [
            "800",
            "750",
            "700",
            "600",
            "500",
            "450",
            "400",
            "350",
            "300",
            "275",
            "250",
            "225",
            "200",
            "175",
            "150",
            "125",
            "100"
          ],
          "style": "high"
        }
      ]
    },
    "style": {
      "default": {
        "contour": [
          {
            "base": -198,
            "interval": 3,
            "num": 250,
            "strokeStyle": "rgba(128, 0, 0, 0.8)",
            "textColor": "rgba(128, 0, 0, 0.8)"
          }
        ]
      },
      "low": {
        "contour": [
          {
            "base": -198,
            "interval": 3,
            "num": 250,
            "strokeStyle": "rgba(128, 0, 0, 0.8)",
            "textColor": "rgba(128, 0, 0, 0.8)"
          }
        ]
      },
      "high": {
        "contour": [
          {
            "base": -198,
            "interval": 6,
            "num": 250,
            "strokeStyle": "rgba(128, 0, 0, 0.8)",
            "textColor": "rgba(128, 0, 0, 0.8)"
          }
        ]
      }
    }
  }
}

// 気温 色塗り Gradation
export const configLfmUpperLayerIsothermGradation = {
  "Name": "GPVTempFillGradation",
  "Renderer": "Mesh",
  "Attributes": {
    "data_offset": -273.15,
    "style": {
      "default": {
        "fill_type": "gradation",
        "palette_gradient": true,
        "palette_step": 1,
        "palette": [
          {
            "value": -96.0,
            "color": "rgba(  47,   6,  81, 0.5)"
          },
          {
            "value": -48.0,
            "color": "rgba(  73,  32, 107, 0.5)"
          },
          {
            "value": -36.0,
            "color": "rgba(   0,  32, 128, 0.5)"
          },
          {
            "value": -24.0,
            "color": "rgba(   0,  65, 255, 0.5)"
          },
          {
            "value": -12.0,
            "color": "rgba(   0, 150, 255, 0.5)"
          },
          {
            "value": -6.0,
            "color": "rgba( 185, 235, 255, 0.5)"
          },
          {
            "value": 0.0,
            "color": "rgba( 233, 255, 237, 0.5)"
          },
          {
            "value": 6.0,
            "color": "rgba(   0, 255, 184, 0.5)"
          },
          {
            "value": 12.0,
            "color": "rgba(   1, 249,  15, 0.5)"
          },
          {
            "value": 18.0,
            "color": "rgba( 255, 255, 150, 0.5)"
          },
          {
            "value": 24.0,
            "color": "rgba( 250, 245,   0, 0.5)"
          },
          {
            "value": 30.0,
            "color": "rgba( 255, 153,   0, 0.5)"
          },
          {
            "value": 36.0,
            "color": "rgba( 255,  40,   0, 0.5)"
          },
          {
            "value": 42.0,
            "color": "rgba( 180,   0, 104, 0.5)"
          },
          {
            "value": 48.0,
            "color": "rgba( 168,   0, 255, 0.5)"
          }
        ]
      }
    }
  }
}

// 気温 グリッド値
export const configLfmUpperLayerIsothermGrid = {
  "Name": "GPVTempGridValue",
  "Renderer": "GridValueExt",
  "Attributes": {
    "data_offset": -273.15,
    "style": {
      "default": {
        "min_blocksize": 40,
        "overlap_range": 80,
        "fractional_digits": 0,
        "color": "rgba(0, 0, 0, 1.0)",
        "offset_x": 0,
        "offset_y": 6
      },
      "dark": {
        "min_blocksize": 40,
        "overlap_range": 80,
        "fractional_digits": 0,
        "color": "rgba(255, 255, 255, 1.0)",
        "offset_x": 0,
        "offset_y": 6
      }
    }
  }
};

// ジオポテンシャル高度 等値線
export const configLfmUpperLayerGeoPotentialHeight = {
  "Name": "GeoPotentialHeight",
  "Renderer": "Contour",
  "Attributes": {
    "data_offset": 0,
    "style_selector": {
      "key": "level",
      "styles": [
        {
          "values": ["1000", "975", "950", "925", "900", "850", "800", "750", "700", "600", "500"],
          "style": "low"
        },
        {
          "values": ["450", "400", "350", "300", "275", "250", "225", "200", "175", "150", "125", "100"],
          "style": "high"
        }
      ]
    },
    "style": {
      "default": {
        "contour": [
          {
            "base": 0,
            "interval": 60,
            "num": 120,
            "strokeStyle": "rgba(0, 255, 0, 0.8)",
            "textColor": "rgb(10,175,10)"
          }
        ]
      },
      "low": {
        "contour": [
          {
            "base": 0,
            "interval": 60,
            "num": 120,
            "strokeStyle": "rgba(0, 255, 0, 0.8)",
            "textColor": "rgb(10,175,10)"
          }
        ]
      },
      "high": {
        "contour": [
          {
            "base": 4200,
            "interval": 120,
            "num": 120,
            "strokeStyle": "rgba(0, 255, 0, 0.8)",
            "textColor": "rgb(10,175,10)"
          }
        ]
      }
    }
  }
}

// 着氷の指標
export const configLfmUpperLayerIcingProb = {
  "Name": "IcingProbavility",
  "Renderer": "GridIcon",
  "Attributes": {
    "style": {
      "default": {
        "min_blocksize": 20,
        "settings": [
          {
            "eq": 1,
            "type": "text",
            "text": "✱",
            "text_color": "#000000"
          }
        ]
      },
      "dark": {
        "min_blocksize": 20,
        "settings": [
          {
            "eq": 1,
            "type": "text",
            "text": "＊",
            "text_color": "#c4c2c2"
          }
        ]
      }
    }
  }
};


// 相対湿度（コンター）
export const configLfmUpperLayerRelativeHumidityContour = {
  "Name": "RelativeHumidityContour",
  "Renderer": "Contour",
  "Attributes": {
    "_data_offset": 0,
    "_data_scale": 1,
    "style": {
      "default": {
        "contour": [
          {
            "base": 0,
            "interval": 5,
            "num": 21,
            "unit_label": "%",
            "label_interval" : 256,
            "max_label_num" : 3,
            "strokeStyle": "rgba(0, 0, 255, 0.5)",
            "textColor": "rgb(0, 0, 255)"
          }
        ]
      }
    }
  }
};

// 相対湿度（グラデーション）
export const configLfmUpperLayerRelativeHumidityGradation = {
  "Name": "RelativeHumidityFill",
  "Renderer": "Mesh",
  "Attributes": {
    "style": {
      "default": {
        "fill_type": "gradation",
        "palette_gradient": true,
        "palette_step": 1,
        "palette": [
          {
            "value": 70,
            "color": "rgba(184, 241, 241, 0.5)"
          },
          {
            "value": 75,
            "color": "rgba(149, 234, 234, 0.5)"
          },
          {
            "value": 80,
            "color": "rgba(78, 220, 220, 0.5)"
          },
          {
            "value": 85,
            "color": "rgba(35, 177, 177, 0.5)"
          },
          {
            "value": 90,
            "color": "rgba(29, 141, 141, 0.5)"
          },
          {
            "value": 95,
            "color": "rgba(21, 106, 106, 0.5)"
          },
          {
            "value": 100,
            "color": "rgba(14, 71, 71, 0.5)"
          }
        ]
      }
    }
  }
};